import styled from "styled-components";

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 25px;
  padding: 0 1px;

  h5 {
    font-size: 18px;
    font-weight: bold;
    color: #343536;
  }
`;

export const BoxDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  h5 {
    font-size: 18px;
    font-weight: bold;
    color: #343536;
  }
`;

export const BoxIndication = styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
  border: 1px solid #eeeff1;

  padding: 5px 15px;
  h5 {
    font-size: 18px;
    font-weight: bold;
    color: #343536;
    margin: 10px 0;
  }
`;

export const BoxButtons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  margin-top: 15px;
  padding-bottom: 15px;
  gap: 20px;
`;

export const BtnFixed = styled.div`
  display: flex;
  flex-direction: row;
  gap: 25px;
  padding: 15px 0;
`;

export const AriaBox = styled.div`
  background-color: white;
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 20px 10px;
  gap: 10px;

  label {
    padding: 5px 8px;
    background-color: #f7f8fa;
    margin-left: 10px;
  }
`;

export const AllComplements = styled.div`
  background-color: #f7f8fa;
  padding: 5px 15px;
  margin: 5px 0;
`;

export const ContentComplement = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 10px;
`;
